export default __webpack_public_path__ + "static/media/la_defense_plane.f7b9c6e8.jpg";